<template>
    <CodiceFeanorView tool-module="keyConverter" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
